import React from "react";
import { Box, Button, Alert, Text, VirtuazlizedList } from "common";
import { useStyles } from "../../BulkBundleUtility/BulkUploadJobs/BulkJobs.style";

type IProps = {
  updateApprovalScreen?: () => void;
  onCloseNotification?: () => void;
  isLoading?: boolean;
  onSubmit?: () => void;
  error?: string;
  errorList?: string[];
};

const ApprovalBundleScreen: React.FC<IProps> = ({
  updateApprovalScreen,
  onCloseNotification,
  isLoading,
  onSubmit,
  error,
  errorList = [],
}) => {
  const { wrapText } = useStyles();
  return (
    <Box px={2} pb={2}>
      {error && (
        <Alert
          data-testid="error-notification"
          padding="5px 15px"
          width="100%"
          variant="outlined"
          severity="error"
          onClose={onCloseNotification}
          margin="15px 0"
        >
          {error || "Something went wrong"}
        </Alert>
      )}
      {errorList.length > 0 && (
        <Alert
          data-testid="bulk-upload-error"
          padding="5px"
          width="100%"
          variant="outlined"
          severity="error"
          margin="15px 0"
        >
          <Box m="8px">
            {errorList.length > 5 ? (
              <Box className={wrapText}>
                <VirtuazlizedList
                  itemData={errorList}
                  height={170}
                  width={390}
                  itemSize={75}
                  itemCount={errorList.length}
                  containerStyles={{
                    height: 170,
                    width: "100%",
                  }}
                />
              </Box>
            ) : (
              errorList?.map((error, index) => (
                <Text
                  key={`error-${index}`}
                  style={{
                    fontSize: "1rem",
                    fontWeight: "400",
                    lineHeight: "1.5",
                  }}
                >
                  {error}
                </Text>
              ))
            )}
          </Box>
        </Alert>
      )}
      <Box display="flex" justifyContent="space-between">
        <Button
          variant="outlined"
          data-testid="confirmation-cn-btn"
          onClick={updateApprovalScreen}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          data-testid="confirmation-btn"
          isLoading={isLoading}
          onClick={onSubmit}
          disabled={errorList.length > 0}
        >
          Confirm
        </Button>
      </Box>
    </Box>
  );
};

export default ApprovalBundleScreen;
